import { Card } from "@/components/ui/card";
import type { UsageTotals } from "../lib/aggregate";
import { formatTokens, formatUsd } from "../lib/format";
import { Cloud, Key } from "@phosphor-icons/react";

interface Props {
  platform: UsageTotals;
  user: UsageTotals;
}

export function UsageBillingSplit({ platform, user }: Props) {
  const hasUser = user.callCount > 0;
  if (!hasUser) return null;

  return (
    <Card className="p-5">
      <h3 className="text-sm font-semibold text-foreground tracking-tight mb-4">
        Plataforma vs sua chave (BYOK)
      </h3>
      <div className="grid grid-cols-2 gap-4">
        <Row icon={Cloud} label="Plataforma" totals={platform} hint="Pago pelo app" />
        <Row
          icon={Key}
          label="Sua chave (BYOK)"
          totals={user}
          hint="Custo estimado na sua conta do provider"
        />
      </div>
    </Card>
  );
}

function Row({
  icon: Icon,
  label,
  totals,
  hint,
}: {
  icon: typeof Cloud;
  label: string;
  totals: UsageTotals;
  hint: string;
}) {
  return (
    <div className="rounded-lg border border-white/[0.05] bg-card/50 p-3">
      <div className="flex items-center gap-2 mb-2">
        <Icon weight="duotone" className="h-4 w-4 text-primary" aria-hidden="true" />
        <span className="text-xs uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
      </div>
      <p
        className="text-lg font-semibold text-foreground tabular-nums"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {formatUsd(totals.costUsd)}
      </p>
      <p className="text-xs text-muted-foreground">
        {formatTokens(totals.totalTokens)} tokens · {totals.callCount} calls
      </p>
      <p className="text-[11px] text-muted-foreground/70 mt-1">{hint}</p>
    </div>
  );
}
